module.exports = __webpack_public_path__ + "media/assets/images/bulloni_digitali/cosa-e-un-erp-78d5360db811ccae38c9fbbe29a64587.png";